/**
 * Флаги прав `can` из ответов админки (docs/backend/conventions.md §4.5):
 * карточки и строки — `can: {update, delete, publish, …}`, списки — `can: {create, export}`.
 * Fail-closed: действие разрешено, только если флаг присутствует и строго равен true.
 * Проверка на фронте — только отражение прав; защита — на сервере (403/404).
 */
export type Abilities = Readonly<Record<string, unknown>>;

export function can(abilities: Abilities | null | undefined, action: string): boolean {
  if (!abilities) return false;
  return Object.hasOwn(abilities, action) && abilities[action] === true;
}

/** Есть ли хотя бы одно разрешённое действие из перечисленных. */
export function canAny(
  abilities: Abilities | null | undefined,
  actions: readonly string[],
): boolean {
  return actions.some((action) => can(abilities, action));
}
